<template>
  <div>
    <div>
      <NavigationBreadcrumb :items="breadcrumb_items"></NavigationBreadcrumb>
      <h3 class="mt-3">
        {{
          $getVisibleNames("mesh.timeallocation", true, "Divisiones de tiempo")
        }}
        <AlternativeNameButton
          :table_name="'mesh.timeallocation'"
          :allows_crud="allows_crud"
        ></AlternativeNameButton>
      </h3>
      <div style="display: flex">
        <div class="col" style="text-align: left">
          <ButtonMedium
            v-can="'mesh.add_timeallocation'"
            v-if="allows_crud"
            :tooltip_text="
              $t('reusable.common.addTooltip', {
                entity: $getVisibleNames(
                  'mesh.timeallocation',
                  false,
                  'División de tiempo'
                ),
              })
            "
            :text_button="$t('reusable.common.add')"
            :click_button="() => $bvModal.show(`new-time-allocation-modal`)"
            :icon="'plus'"
            :variant="'primary'"
          >
          </ButtonMedium>
        </div>
      </div>
      <GenericBTable
        class="time-allocation-table"
        :items="time_allocations"
        :pagination="10"
        :filterCustom="filterCustom"
        @emitChangeSearchField="changeInputSearch"
        :fields="time_allocations_fields"
        :filter="input_search"
        :show_pagination="true"
        :search_filter="true"
        :columns_display="true"
        :allows_crud="allows_crud"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
      >
        <template #cell(study_environment)="row">
          <div class="study-environment-container">
            <template v-if="row.item.has_study_environments">
              <div
                v-for="item in getStudyEnvironment(row.item.id)"
                :key="item.id"
                class="kl-chip"
              >
                {{ item.name }}
              </div>
            </template>
            <template v-else>N/A</template>
          </div>
        </template>
        <template v-if="allows_crud" #cell(actions)="row">
          <ButtonSmall
            :icon="'square'"
            :tooltip_text="
              $t('reusable.common.editTooltip', {
                entity: $getVisibleNames(
                  'mesh.timeallocation',
                  false,
                  'División de tiempo'
                ),
              })
            "
            :click_button="
              () => $bvModal.show(`edit-time-allocation-modal-${row.item.id}`)
            "
            :class="``"
          ></ButtonSmall>
          <span
            v-if="
              institution &&
              institution.internal_use_id == 'duoc.cl' &&
              row.item.internal_use_id != null
            "
            v-b-tooltip.v-secondary.auto.noninteractive="
              `${
                [
                  'duoc_lab_hours',
                  'duoc_computer_hours',
                  'duoc_field_hours',
                  'duoc_practice_hours',
                ].includes(row.item.internal_use_id)
                  ? $t(
                      'organizationalDefinitions.timeAllocation.requiredForTeacherProfiles'
                    )
                  : $t(
                      'organizationalDefinitions.timeAllocation.requiredForDidacticBriefcase'
                    )
              }`
            "
          >
            <ButtonSmall
              :disabled_button="true"
              :tooltip_text="``"
              :icon="'trash'"
            ></ButtonSmall>
          </span>
          <ButtonSmall
            v-else
            :click_button="() => askForDeleteTimeAllocation(row.item.id)"
            :tooltip_text="
              $t('reusable.common.deleteTooltip', {
                entity: $getVisibleNames(
                  'mesh.timeallocation',
                  false,
                  'División de tiempo'
                ),
              })
            "
            :icon="'trash'"
          ></ButtonSmall>
          <b-modal
            :id="`edit-time-allocation-modal-${row.item.id}`"
            :title="
              $t('reusable.common.editModalTitle', {
                entity: $getVisibleNames(
                  'mesh.timeallocation',
                  false,
                  'División de tiempo'
                ),
              })
            "
            size="lg"
            hide-footer
          >
            <TimeAllocationForm
              :TimeAllocation="row.item"
              @updated="slotUpdatedTimeAllocation"
              :show_title="false"
            ></TimeAllocationForm>
          </b-modal>
        </template>
      </GenericBTable>
    </div>
    <b-modal
      :id="`new-time-allocation-modal`"
      :hide-footer="true"
      :title="
        $t('reusable.common.createModalTitle', {
          entity: $getVisibleNames(
            'mesh.timeallocation',
            false,
            'División de tiempo'
          ),
        })
      "
      size="lg"
    >
      <TimeAllocationForm
        @created="slotCreatedTimeAllocation"
        :maxOrder="maxOrder"
        :show_title="false"
      ></TimeAllocationForm>
    </b-modal>
  </div>
</template>
<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { toast } from "@/utils/utils";
import { periodicityLabel } from "@/utils/academicLoad";
export default {
  name: "TimeAllocationView",
  components: {
    TimeAllocationForm: () =>
      import(
        "@/components/mesh/CurricularResources/TimeAllocation/TimeAllocationForm"
      ),
    GenericBTable: () => import("@/components/reusable/GenericBTable"),
    AlternativeNameButton: () =>
      import("@/components/reusable/AlternativeNameButton"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
  },
  props: {},
  data() {
    return {
      input_search: "",
      sortBy: "",
      sortDesc: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      institution: "getInstitution",
      time_allocations: names.TIME_ALLOCATIONS,
      studyEnvironments: names.STUDY_ENVIRONMENTS,
      studyEnvironmentsTimeAllocation: names.STUDY_ENVIRONMENTS_TIME_ALLOCATION,
      classroom_types: names.CLASSROOM_TYPES,
    }),
    breadcrumb_items() {
      return [
        { text: this.$t("reusable.breadcrumb.home"), to: "/home" },
        {
          text: this.$getVisibleNames(
            "mesh.timeallocation",
            true,
            "Divisiones de tiempo"
          ),
        },
      ];
    },
    allows_crud() {
      const has_permission = this.$hasPermissions("mesh.add_timeallocation");
      if (has_permission && this.user && this.user.is_superuser)
        return has_permission;
      else return false;
    },
    maxOrder() {
      let order = 0;
      this.time_allocations.forEach((x) => {
        if (order < x.order) order = x.order;
      });
      return order + 1;
    },
    time_allocations_fields() {
      return [
        {
          key: "name",
          label: String(
            this.$getVisibleNames(
              "mesh.timeallocation",
              true,
              "Divisiones de tiempo"
            )
          ),
          sortable: true,
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "counts_towards_credits",
          label: this.$t(
            "organizationalDefinitions.timeAllocation.includeInTotalHoursDefault"
          ),
          sortable: true,
          display_column: true,
          formatter: (value) => {
            return value
              ? this.$t("organizationalDefinitions.timeAllocation.yes")
              : this.$t("organizationalDefinitions.timeAllocation.no");
          },
        },
        {
          key: "uses_module_minutes",
          label: this.$t("organizationalDefinitions.timeAllocation.hourType"),
          sortable: true,
          display_column: true,
          formatter: (value) => {
            return value
              ? this.$t("organizationalDefinitions.timeAllocation.pedagogical")
              : this.$t(
                  "organizationalDefinitions.timeAllocation.chronological"
                );
          },
        },
        {
          key: "attendance_requirement",
          label: this.$t(
            "organizationalDefinitions.timeAllocation.attendanceRequiredDefault"
          ),
          sortable: true,
          display_column: true,
          formatter: (value) => {
            return value != null && value != ""
              ? value
              : this.$t("organizationalDefinitions.timeAllocation.noApply");
          },
        },
        this.$showsStudentsCount(this.institution)
          ? {
              key: "students_per_hour",
              label: this.$t(
                "organizationalDefinitions.timeAllocation.studentsPerHourDefault"
              ),
              sortable: true,
              display_column: true,
              formatter: (value) => {
                return value != null && value != ""
                  ? value
                  : this.$t("organizationalDefinitions.timeAllocation.noApply");
              },
            }
          : "",
        this.$usesAcademicLoad(this.institution)
          ? {
              key: "classroom_type",
              label: this.$t("studyPlan.academicLoad.classroomType"),
              sortable: false,
              display_column: true,
              formatter: (value) => {
                const classroom_type = this.classroom_types.find(
                  (x) => x.id == value
                );
                return classroom_type ? classroom_type.name : "-";
              },
            }
          : "",
        this.$usesAcademicLoad(this.institution)
          ? {
              key: "periodicity",
              label: this.$t("studyPlan.academicLoad.periodicity"),
              sortable: true,
              display_column: true,
              formatter: (value) => periodicityLabel(this.$t.bind(this), value),
            }
          : "",
        {
          key: "order",
          label: this.$t("reusable.common.order"),
          sortable: true,
          display_column: true,
        },
        this.institution && this.institution.show_study_environment_menu
          ? {
              key: "study_environment",
              label: this.$getVisibleNames(
                "mesh.studyenvironment",
                true,
                "Ambientes de Aprendizaje"
              ),
              sortable: false,
              display_column: true,
            }
          : "",
        // {
        //   key: "internal_use_id",
        //   label: "internal_use_id",
        //   sortable: false,
        //   display_column: true,
        // },
        {
          key: "actions",
          label: "",
          display_column: true,
          thClass: "noprint",
          tdClass: "noprint",
        },
      ];
    },
  },
  methods: {
    filterCustom(row) {
      if (
        this.$filtered(row.name, this.input_search) ||
        this.$filtered(row.order, this.input_search) ||
        this.$filtered(
          row.uses_module_minutes
            ? this.$t("organizationalDefinitions.timeAllocation.pedagogical")
            : this.$t("organizationalDefinitions.timeAllocation.chronological"),
          this.input_search
        ) ||
        this.studyEnvironments.filter(
          (x) =>
            this.$filtered(x.name, this.input_search) &&
            this.studyEnvironmentsTimeAllocation.find(
              (sETA) =>
                sETA.time_allocation == row.id && sETA.study_environment == x.id
            )
        ).length > 0
      ) {
        return true;
      } else return false;
    },
    changeInputSearch(input_search) {
      this.input_search = input_search;
    },
    getStudyEnvironment(time_allocation_id) {
      const study_environment_ids = [
        ...new Set(
          this.studyEnvironmentsTimeAllocation
            .filter((x) => x.time_allocation == time_allocation_id)
            .map((x) => x.study_environment)
        ),
      ];
      return this.studyEnvironments.filter((x) =>
        study_environment_ids.includes(x.id)
      );
    },
    askForDeleteTimeAllocation(time_allocation_id) {
      this.$swal({
        title: `¿Está seguro de que desea eliminar esta instancia de "${this.$getVisibleNames(
          "mesh.timeallocation",
          false,
          "División de tiempo"
        )}"?`,
        text: "¡Esta acción no se podrá revertir!",
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch(names.DELETE_TIME_ALLOCATION, time_allocation_id)
            .then(() => {
              toast(
                String(
                  this.$getVisibleNames(
                    "mesh.timeallocation",
                    false,
                    "División de tiempo"
                  ) +
                    " " +
                    this.$t("reusable.common.deleted")
                )
              );
            });
        }
      });
    },
    slotCreatedTimeAllocation() {
      this.$bvModal.hide("new-time-allocation-modal");
    },
    slotUpdatedTimeAllocation(time_allocation) {
      this.$bvModal.hide(`edit-time-allocation-modal-${time_allocation.id}`);
    },
  },
  mounted() {
    this.$store.dispatch(names.FETCH_STUDY_ENVIRONMENTS_TIME_ALLOCATION);
    this.$store.dispatch(names.FETCH_TIME_ALLOCATIONS);
    this.$store.dispatch(names.FETCH_STUDY_ENVIRONMENTS);
  },
  created() {
    if (this.$usesAcademicLoad(this.institution))
      this.$store.dispatch(names.FETCH_CLASSROOM_TYPES);
  },
};
</script>
<style scoped>
.td-actions {
  max-width: 100px !important;
}
.title-header {
  padding: 0 1rem;
  margin-top: auto;
}
.search-time-allocation {
  max-width: 50rem;
  margin-left: auto;
  margin-right: 18.5%;
  margin-bottom: 1rem;
  margin-top: 0.5rem;
}
.edit-section {
  margin-top: -2%;
}
.study-environment-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: left;
  gap: 3px;
  overflow-y: auto;
  max-height: 200px;
}
</style>